export const DEVICE_TYPE_OPTIONS = [
  { value: 'neoVI RED2', label: 'neoVI RED2' },
  { value: 'Fire 3 Compute', label: 'Fire 3 Compute' },
  { value: 'Pi4B', label: 'Pi4B' },
  { value: 'F3S', label: 'F3S' },
  { value: 'F3C', label: 'F3C' },
  { value: 'SDX-Pi4B', label: 'SDX-Pi4B' },
  { value: 'CM5', label: 'CM5' },
  { value: 'SDX-Pi0', label: 'SDX-Pi0' },
  { value: 'Laptop', label: 'Laptop' },
];

const DEVICE_TYPE_ALIAS_MAP = new Map([
  ['neovi red2', 'neoVI RED2'],
  ['neovi-red2', 'neoVI RED2'],
  ['fire 3 compute', 'Fire 3 Compute'],
  ['fire3 compute', 'Fire 3 Compute'],
  ['fire-3-compute', 'Fire 3 Compute'],
  ['pi4b', 'Pi4B'],
  ['pi 4b', 'Pi4B'],
  ['pi-4', 'Pi4B'],
  ['pi 4', 'Pi4B'],
  ['pi-4b', 'Pi4B'],
  ['f3s', 'F3S'],
  ['f3c', 'F3C'],
  ['sdx-pi4b', 'SDX-Pi4B'],
  ['sdxpi4b', 'SDX-Pi4B'],
  ['cm5', 'CM5'],
  ['sdx-pi0', 'SDX-Pi0'],
  ['sdxpi0', 'SDX-Pi0'],
  ['laptop', 'Laptop'],
]);

export const normalizeDeviceType = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  const trimmed = String(value).trim();
  if (!trimmed) {
    return '';
  }

  return DEVICE_TYPE_ALIAS_MAP.get(trimmed.toLowerCase()) || trimmed;
};

export const supportsSignalStrength = (value) => normalizeDeviceType(value).startsWith('Fire 3');

export const isStandardDeviceType = (value) => DEVICE_TYPE_OPTIONS.some((option) => option.value === value);

export const getDeviceTypeOptionsWithLegacy = (selectedValue = '') => {
  const normalizedValue = normalizeDeviceType(selectedValue);

  if (!normalizedValue || isStandardDeviceType(normalizedValue)) {
    return DEVICE_TYPE_OPTIONS;
  }

  return [
    ...DEVICE_TYPE_OPTIONS,
    { value: normalizedValue, label: `${normalizedValue} (legacy)` },
  ];
};

export const formatDeviceType = (value) => normalizeDeviceType(value) || 'Not available';